import React from 'react';
import '../styles/quoteSection/quoteSection.min.css';

const QuoteSection = () => {
    return (
        <div className='w-100 d-flex align-items-center justify-content-center quote-container section-separator'>
            <p className='display-6 text-center p-3 m-0 bg-transp'>VIAJAR <span className='bg-transp depth'>AMPLIA</span> A MENTE... AGIR <span className='bg-transp depth'>TRANSFORMA</span> O MUNDO!</p>
        </div>
    );
}

export default QuoteSection;